import wixUsers from 'wix-users';
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location'
import { checkMemberTerms } from 'backend/user';
// The code in this file will load on every page of your site

let userId

$w.onReady(function () {
    //wixWindow.openLightbox('BreakIsOver');
    //$w('#countdownClock2').
    addLogActivity();
    /*
    let nowTime = new Date(), today = nowTime., hour = nowTime.getHours();
    if(today >= 1 && today <= 5 && hour >= 8 && hour <= 15){
    //code
    } */

    wixUsers.onLogin((user) => {
        userId = user.id;

        checkMemberTerms(userId) // check if the user approve website terms at registration
            .then((approve) => {

                if (!approve)
                    wixWindow.openLightbox("ApproveTerms", { "userId": userId })

            })
    })

})

async function addLogActivity() {
    if (wixUsers.currentUser.loggedIn) userId = await wixUsers.currentUser.id;

    let referrer = wixWindow.referrer; // "http://somesite.com"
    let deviceType = wixWindow.formFactor; // "Mobile"
    let url = wixLocation.url;
    let description = 'Visit';

    //let user = await wixUsersBackend.getUser(userId);
    //onsole.log ('user details: ', user)

    let toInsert = {
        "userId": userId,
        "logMemberId": userId,
        "referrer": referrer,
        "deviceType": deviceType,
        "url": url,
        "description": description,

    };

    wixData.insert("log", toInsert)
        .then((results) => {
            //console.log('Info wrote to log data: ', results)
            //let item = results; //see item below
        })
        .catch((err) => {
            let errorMsg = err;
        })
}